import { Routes, Route, useNavigate, Navigate } from "react-router-dom";
import React, { useEffect, useState } from "react";
import { connect, useDispatch } from "react-redux";
import Login from "../Login";
import withRouter from "../components/custom/withRouter";
import TopBar from "../components/pages/layout/TopBar";
import Documents from "../components/pages/documents/Document";
import Favorites from "../components/pages/myFavourites/Favourites";
import MyRequest from "../components/pages/mycompletedtask/MyRequest";
import SearchResult from "../../src/components/pages/layout/rightbar components/SearchResults";
import Ledger from "../components/pages/settings/Ledger";
import Category1 from "../components/pages/masterdata/Category1";
import Category2 from "../components/pages/masterdata/Category2";
import ExpiryPeriod from "../components/pages/settings/ExpiryPeriod";
import MyPendingTask from "../components/pages/pending/MyPendingTask";
import Viewbar from "../components/pages/layout/Viewbar";
import { UserNotFound } from "../components/pages/userNotFound";
import API from '../helpers/endpointService'
import axios from "axios";
import { SessionExpired } from "../components/pages/sessionExpired";
import { CookiesProvider } from "react-cookie";

const isUserValid = localStorage.getItem("isUserValid");
const userId = localStorage.getItem("UserId");

class Routing extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isMobile: false
    }
  }

  componentDidMount() {
    const userDetails = localStorage.getItem("userData");
    let userToken = JSON.parse(userDetails);
    if (userToken) {
      axios.defaults.headers.common['Authorization'] = `Bearer ${userToken.id_token}`;
    }
    const intervals = setInterval(() => {
      this.resize();
    }, 10);
  }
  resize = () => {
    if (window.innerWidth < 850) {
      this.state.isMobile = true;
    } else {
      this.state.isMobile = false;
    }
    this.setState({})
  }

  componentWillMount() {
    axios.interceptors.request.use(
      (config) => {
        const userDetails = localStorage.getItem("userData");
        let userToken = JSON.parse(userDetails);
        if (userToken) {
          config.headers["Authorization"] = "Bearer " + userToken.id_token;
        }
        return config;
      },
      function (error) {
        return Promise.reject(error);
      }
    );

    axios.interceptors.response.use(
      function (response) {
        return response;
      },
      function (error) {
        return Promise.reject(error);
      }
    );
  }

  render() {
    const { menuToggle } = this.props;
    return (
      <>
        <div className="main-outer-container">
          {(window.location.pathname == "/usernotfound" || window.location.pathname == "/sessionexpired")  ? "" :
           ( window.location.pathname !== "/" && (
              <div className={this.state.isMobile === true ? "" : menuToggle ? "main-sidebar-toggle" : "main-sidebar"}>
                <TopBar />
              </div>)
            )}
          <CookiesProvider>
          <Routes>
            <Route exact path="/" element={<Login />} />
            <Route path="/pendingtasks" element={<MyPendingTask />} />
            <Route path="/favourites" element={<Favorites />} />
            <Route exact path="/documents/*" element={<Documents />} />
            <Route exact path="/search" element={<SearchResult />} />
            <Route path="/documentrequests" element={<MyRequest />} />
            <Route path="/myactions" element={<MyRequest />} />
            <Route path="/ledger" element={<Ledger />} />
            <Route path="/category1" element={<Category1 />} />
            <Route path="/category2" element={<Category2 />} />
            <Route path="/notificationperiod" element={<ExpiryPeriod />} />
            <Route path="/usernotfound" element={<UserNotFound />} />
            <Route path="/sessionexpired" element={<SessionExpired />} />
          </Routes>
          </CookiesProvider>
          <Viewbar />
        </div>
      </>
    );
  };
}

function mapDispatchToProps(dispatch) {
  return {
    dispatch,
  };
}

function mapStateToProps(state) {
  return {
    menuToggle: state.commonReducer.menuToggle,
  };
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Routing));
